/** Renderização local de textos para rascunhos: nunca executa HTML nem expressões. */
const MONTHS = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];
export function renderNfseCustomerDescription(template, { customerName = '', competenceDate = '' } = {}) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(competenceDate));
  const year = match?.[1] || '';
  const monthIndex = match ? Number(match[2]) - 1 : -1;
  const month = MONTHS[monthIndex] || '';
  const competence = month ? String(monthIndex + 1).padStart(2, '0') + '/' + year : '';
  const values = { cliente: String(customerName || '').trim(), mes: month, ano: year, competencia: competence };
  return String(template || '').replace(/\{\{\s*(cliente|mes|ano|competencia)\s*\}\}/gi,
    (_, key) => values[key.toLowerCase()] || '');
}

export function composeNfseDescription(customerText, generalText, context) {
  return [customerText, generalText].map(text => renderNfseCustomerDescription(text, context).trim()).filter(Boolean).join('\n\n');
}
